import React from 'react';
import { Wind } from 'lucide-react';
import TonePlayer from './TonePlayer';

const Label = ({ children }) => <p className="font-body text-xs font-semibold uppercase tracking-[0.25em] text-[#b07d3c] mb-3">{children}</p>;

const Swatch = ({ item, kind, testId }) => (
  <div className="bg-white rounded-2xl border border-[#eadfcc] p-6" data-testid={testId}>
    <Label>{kind}</Label>
    <div className="flex items-center gap-3 mb-2">
      <span className="w-6 h-6 rounded-full border border-stone-300" style={{ background: item.color }} />
      <p className="font-heading text-xl text-[#2b3550]">{item.name}</p>
    </div>
    <p className="font-body text-stone-600 leading-relaxed">{item.meaning}</p>
  </div>
);

export const Practice = ({ week, onBreathe }) => (
  <section className="bg-[#2b3550] text-[#f4ead8] rounded-2xl p-6 md:p-8" data-testid="f2-practice">
    <p className="font-body text-xs font-semibold uppercase tracking-[0.25em] text-[#e9b872] mb-2">This week's practice · {week.practice.type}</p>
    <h3 className="font-heading text-2xl mb-3 text-[#f4ead8]">{week.practice.title}</h3>
    <p className="font-body leading-relaxed text-[#f4ead8]/85 mb-4">{week.practice.description}</p>
    <ul className="space-y-2 mb-6">
      {week.practice.practices.map((p) => (
        <li key={p} className="flex gap-3 font-body text-[#f4ead8]/90"><span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#e9b872] flex-shrink-0" />{p}</li>
      ))}
    </ul>
    <div className="border-t border-[#f4ead8]/15 pt-5">
      <p className="font-body text-xs uppercase tracking-[0.25em] text-[#e9b872] mb-2">Mindful moment</p>
      <p className="font-body leading-relaxed text-[#f4ead8]/85 mb-5">{week.exercise}</p>
      <button onClick={onBreathe} className="inline-flex items-center gap-2 font-body text-sm px-5 py-2.5 rounded-full bg-[#e9b872] text-[#2b3550] hover:bg-[#f0c88a] transition-colors" data-testid="f2-start-breathing">
        <Wind size={16} /> Start Breathing Exercise
      </button>
    </div>
  </section>
);

export const Gifts = ({ week }) => (
  <>
    <section className="text-center py-6" data-testid="f2-affirmation">
      <Label>Affirmation</Label>
      <p className="font-heading italic text-2xl md:text-3xl text-[#2b3550] max-w-2xl mx-auto leading-snug">“{week.affirmation}”</p>
    </section>
    <div className="grid md:grid-cols-2 gap-5">
      <Swatch item={week.crystal} kind="Crystal" testId="f2-crystal" />
      <Swatch item={week.oil} kind="Essential Oil" testId="f2-oil" />
    </div>
    <section className="bg-[#f4ead8] rounded-2xl p-6" data-testid="f2-frequency">
      <Label>Healing Frequency</Label>
      <p className="font-heading text-xl text-[#2b3550]">{week.frequency.hz} Hz · {week.frequency.name}</p>
      <p className="font-body text-stone-600 leading-relaxed mt-1 mb-5">{week.frequency.description}</p>
      <TonePlayer frequency={week.frequency} />
    </section>
  </>
);

export { Label };
